<template>
  <div v-if="sidebarClose">
    <div
      :class="
        sidebarOpen
          ? ' absolute lg:fixed lg:inset-x-0 lg:z-30 lg:flex lg:w-60 lg:flex-col min-h-screen z-50'
          : 'hidden lg:fixed lg:inset-x-0 lg:z-30 lg:flex lg:w-20 lg:flex-col min-h-screen'
      "
    >
      <!--     -->
      <div
        class="flex grow flex-col gap-y-5 bg-dtheme-50 dark:bg-dtheme-900 pb-4 border-r border-gray-200 dark:border-dtheme-700 sidebar close"
      >
        <nav class="flex flex-1 flex-col mt-2">
          <ul
            role="list"
            class="space-y-1 nav-links overflow-y-auto"
            style="max-height: calc(100vh - 4rem)"
          >
            <li
              v-for="(item, index) in currentMenuItems"
              :key="item.name"
              @click="selectedTab(item)"
              class="sm:relative md:static px-3 cursor-pointer"
              @mouseover="showSubItems(index, item)"
              @mouseleave="hideSubItems"
            >
              <template v-if="item.href">
                <router-link
                  :to="{ path: item.href }"
                  :class="[
                    item.current
                      ? 'bg-gray-100 text-blue-800 dark:text-white dark:bg-dtheme-700   '
                      : 'text-gray-700 dark:text-gray-500 hover:text-blue-800 dark:hover:text-white dark:hover:bg-dtheme-700 hover:bg-gray-100',
                    'group flex gap-x-3 rounded-md px-4 py-2 leading-6 items-center',
                  ]"
                >
                  <component
                    :is="item.icon"
                    :class="[
                      item.current
                        ? 'text-blue-800 dark:text-white'
                        : 'text-gray-400 group-hover:text-blue-800 dark:group-hover:text-white',
                      'h-6 w-6 shrink-0',
                    ]"
                    aria-hidden="true"
                  />
                  <span v-if="sidebarOpen" class="text-sm font-medium">{{
                    item.name
                  }}</span>
                </router-link>
              </template>
              <template v-else>
                <span
                  href="#"
                  :class="[
                    item.current
                      ? 'bg-gray-100 text-blue-800 dark:text-white dark:bg-dtheme-700   '
                      : 'text-gray-700 dark:text-gray-500 hover:text-blue-800 dark:hover:text-white dark:hover:bg-dtheme-700 hover:bg-gray-100',
                    'group flex gap-x-3 rounded-md px-4 py-3 leading-6 items-center',
                  ]"
                >
                  <component
                    :is="item.icon"
                    :class="[
                      item.current
                        ? 'text-blue-800 dark:text-white'
                        : 'text-gray-400 group-hover:text-blue-800 dark:group-hover:text-white',
                      'h-6 w-6 shrink-0',
                    ]"
                    aria-hidden="true"
                  />
                  <span v-if="sidebarOpen" class="text-sm font-medium">{{
                    item.name
                  }}</span>
                </span>
              </template>
              <ul
                class="sub-menu sm:absolute opacity-0 border border-gray-200 font-semibold px-3 py-2 z-10 bg-white text-black rounded-r-md dark:bg-dtheme-900 w-60 dark:border-black-300 left-3 top-28 md:left-full md:w-auto h-min"
                v-if="item.subLinks"
                :class="{
                  'sub-items': true,
                  show: activeIndex === index,
                }"
              >
                <li v-for="ele in item.subLinks" :key="ele" class="py-1">
                  <router-link
                    class="link_name whitespace-nowrap"
                    :to="{ path: ele.href }"
                    :class="[
                      ele.current
                        ? 'bg-gray-100 text-blue-800 dark:text-gray-500 dark:bg-dtheme-700'
                        : 'text-gray-700 dark:text-gray-500 hover:text-blue-800 dark:hover:text-white dark:hover:bg-dtheme-700 hover:bg-gray-100',
                      'group flex gap-x-3 rounded-md px-4 py-2 text-sm font-normal',
                    ]"
                    >{{ ele.name }}</router-link
                  >
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import {
  reactive,
  toRefs,
  defineComponent,
  computed,
  onMounted,
  watch,
} from "vue";
import {
  CurrencyRupeeIcon,
  DocumentChartBarIcon,
  CreditCardIcon,
  HomeIcon,
  UserCircleIcon,
  WalletIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  ArrowsRightLeftIcon,
  ArrowTopRightOnSquareIcon,
  DocumentTextIcon,
  GiftIcon,
  DocumentIcon,
  ChartBarIcon,
} from "@heroicons/vue/24/outline";
import { useCommonStore } from "@/store/commonStore";
import { useUserStore } from "@/store/user";
import apiClient from "@/config/axios";
export default defineComponent({
  components: {
    CurrencyRupeeIcon,
    DocumentChartBarIcon,
    CreditCardIcon,
    HomeIcon,
    UserCircleIcon,
    WalletIcon,
    ChatBubbleOvalLeftEllipsisIcon,
    ArrowsRightLeftIcon,
    ArrowTopRightOnSquareIcon,
    DocumentTextIcon,
    GiftIcon,
    DocumentIcon,
    ChartBarIcon,
  },
  setup() {
    const commonStore = useCommonStore();
    const userStore = useUserStore();
    const state = reactive({
      completedOffersObj: "",
      activeIndex: null,
      hidePopupTimeout: null,
      userDetails: computed(() => userStore.getUserName),
      sidebarOpen: computed(() => commonStore.getSidebar),
      sidebarClose: computed(() => commonStore.getSidebar),
      currentMenuItems: [],
      aradminmenuitems: [
        { icon: UserCircleIcon, name: "Dashboard", href: "/" },
        {
          icon: UserCircleIcon,
          name: "Affiliate Home",
          href: "/admAffiliate",
        },
        {
          icon: UserCircleIcon,
          name: "Referral Home",
          href: "/admReferral",
        },
        {
          icon: UserCircleIcon,
          name: "Manage Affiliate",
          href: "/manage-affiliate",
        },
        {
          icon: UserCircleIcon,
          name: "Suspended Affiliate",
          href: "/suspended-affiliate",
        },
        {
          icon: DocumentIcon,
          name: "Affiliate Reporting",
          href: "/affiliateReporting",
        },
      ],
      payadminmenuitems: [
        { icon: UserCircleIcon, name: "Dashboard", href: "/" },
        {
          icon: UserCircleIcon,
          name: "All PayIn/PayOut Data",
          href: "/customer-payin-payout",
        },
        {
          icon: UserCircleIcon,
          name: "All Wallet Data",
          href: "/support-wallet",
        },
        {
          icon: UserCircleIcon,
          name: "Download Holdings",
          href: "/download-holdings",
        },
        {
          icon: DocumentIcon,
          name: "Download TaxPnL",
          href: "/admDownloadTaxpnl",
        },
        {
          icon: CurrencyRupeeIcon,
          name: "User Trades",
          href: "/userTrades",
        },
        {
          icon: DocumentIcon,
          name: "Transaction Discrepancy",
          href: "/transactionDiscrepancy",
        },
        {
          icon: DocumentIcon,
          name: "IPO",
          href: "/ipo",
        },
        {
          icon: DocumentIcon,
          name: "Reset Password",
          href: "/resetPassword",
        },
      ],
      adminmenuitems: [
        { icon: UserCircleIcon, name: "Dashboard", href: "/" },
        {
          icon: UserCircleIcon,
          name: "Account",
          href: "/mydetails",
        },
        {
          icon: UserCircleIcon,
          name: "Discount Master",
          href: "/discount-master",
        },
        {
          icon: UserCircleIcon,
          name: "Product Master",
          href: "/product-master",
        },
        {
          icon: UserCircleIcon,
          name: "Customer Payments",
          href: "/customer-payments",
        },
        {
          icon: UserCircleIcon,
          name: "Customer Subscriptions",
          href: "/customer-subs",
        },
        {
          icon: UserCircleIcon,
          name: "Customer Search",
          href: "/customer-search",
        },
        {
          icon: UserCircleIcon,
          name: "Invoice",
          href: "/customer-invoice",
        },
        {
          icon: UserCircleIcon,
          name: "Wallet Home",
          href: "/add-wallet",
        },
        {
          icon: UserCircleIcon,
          name: "Esign",
          href: "/check-esign",
        },
        {
          icon: ArrowsRightLeftIcon,
          name: "Refresh Cache",
          href: "/refresh-cache",
        },
      ],
      finadminmenuitems: [
        { icon: UserCircleIcon, name: "Dashboard", href: "/" },
        {
          icon: UserCircleIcon,
          name: "All PayIn Data",
          href: "/finance-payin",
        },
        {
          icon: UserCircleIcon,
          name: "All Payout Data",
          href: "/finance-payout",
        },
        {
          icon: UserCircleIcon,
          name: "All Wallet Data",
          href: "/finance-wallet",
        },
        {
          icon: UserCircleIcon,
          name: "Manage Reallocation",
          href: "/manage-reallocation",
        },
        {
          icon: CurrencyRupeeIcon,
          name: "EPI Funds",
          href: "/epiFunds",
        },
        {
          icon: UserCircleIcon,
          name: "Exchange Info",
          href: "/exchange-info",
        },
        {
          icon: UserCircleIcon,
          name: "NRITaxation",
          href: "/nri-taxation",
        },
      ],
      navigation: [
        { name: "Dashboard", href: "/", icon: HomeIcon, current: false },
        {
          name: "Account",
          href: "/mydetails",
          icon: UserCircleIcon,
          current: false,
        },

        {
          name: "Subscriptions",
          icon: CreditCardIcon,
          current: false,
          subLinks: [
            {
              name: "Subscriptions Home",
              href: "/subscriptions",
              current: false,
            },
            {
              name: "Buy Subscription",
              href: "/buy-product",
              current: false,
            },
            {
              name: "Subscription History",
              href: "/payment-history",
              current: false,
            },
          ],
        },
        {
          name: "Holding Report",
          icon: DocumentTextIcon,
          current: false,
          subLinks: [
            { name: "Holding Statement", href: "/holdings", current: false },
            { name: "DP Holding", href: "/dpHoldings", current: false },
            {
              name: "Portfolio Analysis",
              href: "/holdingInsight",
              current: false,
            },
          ],
        },
        {
          name: "Funds",
          icon: CurrencyRupeeIcon,
          current: false,
          subLinks: [
            {
              name: "PayIn",
              href: "/payIn",
              current: false,
            },
            {
              name: "PayOut",
              href: "/payout",
              current: false,
            },
            {
              name: "Funds Re-allocation",
              href: "/fund-reallocation",
              current: false,
            },
            // {
            //   name: "Segment Allocation",
            //   href: "/segment-allocation",
            //   current: false,
            // },
            {
              name: "History",
              href: "/historyOfPayinPayout",
              current: false,
            },
          ],
        },

        {
          name: "Trading Journal",
          icon: DocumentChartBarIcon,
          href: "/journal",
          current: false,
          // subLinks: [
          //   {
          //     name: "Main journal",
          //     href: "/journal",
          //     current: false,
          //   },
          //   {
          //     name: "Verified Journal",
          //     href: "/verifiedJournal",
          //     current: false,
          //   },
          //   {
          //     name: "Profit & Loss Insight",
          //     href: "/profit&Loss",
          //     current: false,
          //   },
          //   // {
          //   //   name: "Statistics & Networth",
          //   //   href: "/statistics&Networth",
          //   //   current: false,
          //   // },
          //   {
          //     name: "Trading Diary",
          //     href: "/tradingdiary",
          //     current: false,
          //   },
          // ],
        },

        {
          name: "P&L Reports",
          icon: DocumentIcon,
          current: false,
          subLinks: [
            { name: "Realized P&L", href: "/realized-P&L", current: false },
            { name: "Unrealized P&L", href: "/unrealized-P&L", current: false },
            { name: "Tax P&L", href: "/tax-P&L", current: false },
            {
              name: "P&L Insight",
              href: "/PnLInsight",
              current: false,
            },
            {
              name: "Segmentwise P&L",
              href: "/SegmentwisePnL",
              current: false,
            },
            // {
            //   name: "Statistics & Networth",
            //   href: "/statistics&Networth",
            //   current: false,
            // },
            {
              name: "P&L Calendar",
              href: "/pnlCalendar",
              current: false,
            },
            {
              name: "Mutual Fund P&L",
              href: "/mutualFundPnL",
              current: false,
            },
          ],
        },

        {
          name: "Reports",
          icon: DocumentTextIcon,
          current: false,
          subLinks: [
            {
              name: "Ledger",
              href: "/ledger",
              current: false,
            },
            // {
            //   name: "Holding",
            //   href: "/holdings",
            //   current: false,
            // },
            { name: "Collateral", href: "/collateral", current: false },
            {
              name: "Trade Register EQ",
              href: "/trade-register",
              current: false,
            },
            {
              name: "Trade Register FNO",
              href: "/FNO-trade-register",
              current: false,
            },
            { name: "Daily Bill", href: "/daily-bill", current: false },
            { name: "Open Position", href: "/open-position", current: false },
            {
              name: "Digital Contract",
              href: "/digital-contract",
              current: false,
            },
            { name: "Margin Client", href: "/margin-client", current: false },
            { name: "Order Book", href: "/orderbook", current: false },
          ],
        },
        {
          name: "Sarathi Score",
          href: "/sarathi-score",
          icon: ChartBarIcon,
          current: false,
        },
        {
          name: "Request",
          href: "/request",
          icon: ArrowTopRightOnSquareIcon,
          current: false,
        },
        {
          name: "Feedback / Incident",
          href: "/feedback",
          icon: ChatBubbleOvalLeftEllipsisIcon,
          current: false,
        },
        {
          name: "Wallet",
          href: "/wallet",
          icon: WalletIcon,
          current: false,
        },
        {
          name: "Referral Home",
          href: "/referral-home",
          icon: ArrowsRightLeftIcon,
          current: false,
        },
        {
          name: "Affiliate Home",
          href: "/affiliate",
          icon: GiftIcon,
          current: false,
        },
        {
          name: "Free Trial",
          href: "/freeSubscription",
          icon: GiftIcon,
          current: false,
        },
        // {
        //   name: "Discount Master",
        //   href: "/discount-master",
        //   icon: GiftIcon,
        //   current: false,
        // },
        // {
        //   name: "Discount Master",
        //   href: "/discount-master",
        //   icon: GiftIcon,
        //   current: false,
        // },
        // {
        //   name: "Customer Search ",
        //   href: "/customer-search",
        //   icon: GiftIcon,
        //   current: false,
        // },
        // {
        //   name: "Product Master ",
        //   href: "/product-master",
        //   icon: GiftIcon,
        //   current: false,
        // },
        // {
        //   name: "Customer Payments ",
        //   href: "/customer-payments",
        //   icon: GiftIcon,
        //   current: false,
        // },
        // {
        //   name: "Customer Subscription ",
        //   href: "/customer-subs",
        //   icon: GiftIcon,
        //   current: false,
        // },
        // {
        //   name: "Finance Payin ",
        //   href: "/finance-payin",
        //   icon: GiftIcon,
        //   current: false,
        // },
        // {
        //   name: "Finance Payout ",
        //   href: "/finance-payout",
        //   icon: GiftIcon,
        //   current: false,
        // },
      ],
    });
    function selectedTab(item) {
      state.currentMenuItems?.forEach((itemInList) => {
        if (item.name == itemInList.name) {
          itemInList.current = true;
        } else {
          itemInList.current = false;
        }
      });
    }

    function clearTimeOutFunc() {
      if (state.hidePopupTimeout) {
        clearTimeout(state.hidePopupTimeout);
        state.hidePopupTimeout = null;
      }
    }
    function showSubItems(index, item) {
      clearTimeOutFunc();
      if (item) {
        selectedTab(item);
      }
      state.activeIndex = index;
    }
    function hideSubItems() {
      if (!state.hidePopupTimeout) {
        state.hidePopupTimeout = setTimeout(() => {
          state.activeIndex = null;
          state.hidePopupTimeout = null;
        }, 100);
      }
    }
    onMounted(() => {
      console.log(window.location.pathname);
      state.navigation.forEach((tab) => {
        if (tab.href === window.location.pathname) {
          tab.current = true;
        } else {
          tab?.subLinks?.forEach((ele) => {
            if (ele.href === window.location.pathname) {
              ele.current = true;
              tab.current = true;
            }
          });
        }
      });
    });

    watch(
      () => state.userDetails,
      () => {
        if (state.userDetails.role.includes("FINPAY_ADMIN")) {
          state.currentMenuItems = [...state.finadminmenuitems];
        } else if (state.userDetails.role.includes("BOPAY_ADMIN")) {
          if (!state.userDetails.role.includes("DEF_SUPPORT_MEM")) {
            const exculdeReferal = [...state.payadminmenuitems].filter(
              (route) => {
                return route.name != "All Wallet Data";
              }
            );
            state.currentMenuItems = exculdeReferal;
          } else {
            state.currentMenuItems = [...state.payadminmenuitems];
          }
        } else if (state.userDetails.role.includes("AR_ADMIN")) {
          state.currentMenuItems = [...state.aradminmenuitems];
        } else if (state.userDetails.role.includes("ROLE_ADM")) {
          state.currentMenuItems = [...state.adminmenuitems];
        } else {
          let filteredNavigation = [...state.navigation];

          if (state.userDetails.zoneMobileIOS) {
            filteredNavigation = filteredNavigation.filter((route) => {
              return route.name !== "Subscriptions";
            });
          }
          if (state.userDetails.role.includes("DEFINEDGE_AFFILIATE")) {
            filteredNavigation = filteredNavigation.filter((route) => {
              return route.name != "Referral Home";
            });
          } else {
            filteredNavigation = filteredNavigation.filter((route) => {
              return route.name != "Affiliate Home";
            });
          }
          //  else {
          //   state.currentMenuItems = [...state.navigation];
          // }
          state.currentMenuItems = filteredNavigation;
          apiClient
            .get("userproductDetails/getofferscompleteddata")
            .then((response) => {
              // debugger;
              if (response.status == 200) {
                debugger;
                state.completedOffersObj = response.data;
                if (
                  state.completedOffersObj != null &&
                  state.completedOffersObj != ""
                ) {
                  debugger;
                  console.log("In if condition :");
                  const exculdeReferal = [...state.currentMenuItems].filter(
                    (route) => {
                      return route.name != "Start My Free Month Trial";
                    }
                  );
                  state.currentMenuItems = exculdeReferal;
                }
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      },
      { immediate: true }
    );

    return {
      ...toRefs(state),
      selectedTab,
      showSubItems,
      hideSubItems,
    };
  },
});
</script>
<style>
/* .sidebar.close .nav-links li .sub-menu {
  left: 100%;
} */
.sidebar.close .nav-links li:hover .sub-menu {
  opacity: 1;
}
.sub-items {
  display: none;
}

.show {
  display: block;
}
</style>
